import { type SuretyQuoteId, SuretyQuoteUnderwritingStatus } from "@inrev/common";
import { useEffect } from "react";
import { useBondRequestSubmissionAdapter } from "../BondRequestSubmissionAdapterContext";

type OutcomeSubscriberProps = {
	quoteId: SuretyQuoteId;
	onOutcome: (outcome: "approved" | "review") => void;
	onProcessing?: () => void;
};

export const OutcomeSubscriber = ({ quoteId, onOutcome, onProcessing }: OutcomeSubscriberProps) => {
	const { useOutcomeQuery } = useBondRequestSubmissionAdapter();
	const { bondRequest } = useOutcomeQuery(quoteId);

	useEffect(() => {
		if (!bondRequest) return;
		const status = bondRequest.underwritingStatus;
		if (
			status === SuretyQuoteUnderwritingStatus.approved ||
			status === SuretyQuoteUnderwritingStatus.review ||
			status === SuretyQuoteUnderwritingStatus.declined
		) {
			onOutcome(status === SuretyQuoteUnderwritingStatus.approved ? "approved" : "review");
			return;
		}
		onProcessing?.();
	}, [bondRequest, onOutcome, onProcessing]);

	return null;
};
